export const RESET_PASSWORD_I18N_PREFIX = "features.login.reset_password";

export const RESET_PASSWORD_I18N_KEYS = {
  title:                                 "title",
  new_password:                          "new_password",
  re_enter_new_password:                 "re_enter_new_password",
  password_mismatch:                     "password_mismatch",
  password_does_not_meet_requirements:   "password_does_not_meet_requirements",
  submit:                                "submit",
  unknown_error_when_resetting_password: "error_resetting_password",
  reset_token_error:                     "reset_token_error",
  password_reset_successfully:           "password_reset_successfully"
};


// WEBPACK FOOTER //
// ./src/features/login/constants/i18n/resetPasswordi18nConstants.js